import React, { PropTypes } from 'react';
import { contentTypes } from '../../langMap';

const Sponsors = (props) => {
  const { data, lang } = props;
  if (data.length === 0) {
    return null;
  }
  return (
    <section className="subsection subsection--sponsors">
      <header className="subsection__header">
        {
          lang === 'ar' ?
            <h2 className="subsection__header__title">{contentTypes.sponsors}</h2> :
            <h2 className="subsection__header__title">Sponsors</h2>
        }
      </header>
      <ul className="sponsors-list">
        { data.map(item =>
          <li className="sponsors-list__item" key={item.id}>
            <img className="sponsors-list__item__logo" src={item.logo} alt={item.name} />
          </li>)
        }
      </ul>
    </section>
  );
};

export default Sponsors;

Sponsors.propTypes = {
  lang: PropTypes.string.isRequired,
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
};



// WEBPACK FOOTER //
// ./js/components/support/Sponsors.js